import { compose, setDisplayName, withProps } from 'recompose';

import {
  KEY_TEXTFIELD_BACKGROUND_COLOR,
  KEY_TEXTFIELD_BORDER_COLOR,
  KEY_TEXTFIELD_BORDER_RADIUS,
  KEY_TEXTFIELD_BORDER_STYLE,
  KEY_TEXTFIELD_BORDER_WIDTH,
} from '../../const/keysBlockStyling';

const StylingToCSSTextfieldOuter = withProps(
  ({
    styling: {
      [KEY_TEXTFIELD_BACKGROUND_COLOR]: backgroundColor,
      [KEY_TEXTFIELD_BORDER_COLOR]: borderColor,
      [KEY_TEXTFIELD_BORDER_RADIUS]: borderRadius,
      [KEY_TEXTFIELD_BORDER_STYLE]: borderStyle,
      [KEY_TEXTFIELD_BORDER_WIDTH]: borderWidth,
    } = {},
  }) => ({
    styleTextfieldOuter: {
      backgroundColor,
      borderColor,
      borderRadius,
      borderStyle,
      borderWidth,
    },
  }),
);

export default compose(
  setDisplayName('StylingToCSSTextfieldOuter'),
  StylingToCSSTextfieldOuter,
);
